module.exports = __webpack_public_path__ + "static/media/scholarship.a2b6da90.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/scholarship.pdf
// module id = 94
// module chunks = 0